export const socialLinks = [
  { url: "https://twitter.com/hirotsu_2", label: "Twitter" },
  { url: "https://www.instagram.com/kazuyahirotsu/", label: "Instagram" },
  { url: "https://www.linkedin.com/in/kazuyahirotsu", label: "LinkedIn" },
  { url: "https://github.com/kazuyahirotsu", label: "GitHub" },
  { url: "https://medium.com/@kazuyahirotsu", label: "Medium" },
  { url: "mailto:hrtkzy4444@outlook.jp", label: "Email" },
];
